/**
 * 원가 · 단가 글 — 회의 2026-10-21 §7 "KRW 글자 빼고 원". KRW 는 "1,234,000 원", 외화는 코드 그대로("1,200 USD"), 통화가 비면 수만.
 * 저장은 그대로(cost_currency) — 표기만. 외화를 송금 환율로 원화 저장하는 건 구매 쪽 공사.
 */

const KRW = 'KRW';
const WON_WORD = '원';

export function costTextOf(amount: number | null, currency: string | null): string {
  if (amount === null) return '—';
  const word = currency === null ? '' : currency === KRW ? WON_WORD : currency;
  return word === '' ? amount.toLocaleString() : `${amount.toLocaleString()} ${word}`;
}
